import React from 'react';
import { StaticReferencePage } from './StaticReferencePage';
import { useData } from '../../contexts/DataContext';
import { useLanguage } from '../../contexts/LanguageContext';
import { TABLE_COLUMNS } from '../../constants/tables';
import { Bank } from '../../types';

export const BanksPage: React.FC = () => {
  const { t } = useLanguage();
  const { banks } = useData();

  return (
    <StaticReferencePage<Bank>
      title={t('references.banks')}
      items={banks.items}
      columns={TABLE_COLUMNS.BANKS}
    />
  );
};
